import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  Button,
  VStack,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';

const MotionBox = motion(Box);

const ContactQuickLinks = ({ data }) => {
  return (
    <Box py={{ base: 12, md: 20 }}>
      <Container maxW="container.xl">
        <MotionBox
          textAlign="center"
          mb={12}
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Heading
            as="h2"
            fontSize={{ base: '2xl', md: '4xl' }}
            color="brand.700"
            mb={4}
          >
            {data.title}
          </Heading>
        </MotionBox>
        <SimpleGrid columns={{ base: 1, md: 3, lg: 3 }} spacing={6}>
          {data.links.map((link, index) => (
            <MotionBox
              key={index}
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <Button
                as={RouterLink}
                to={link.to}
                variant="outline"
                borderColor="brand.300"
                h="auto"
                p={6}
                w="full"
                _hover={{
                  bg: 'accent.gold',
                  borderColor: 'accent.gold',
                  transform: 'translateY(-4px)',
                }}
                transition="all 0.3s"
              >
                <VStack spacing={2}>
                  <Box as={link.icon} size="24px" color="accent.green" />
                  <Text fontWeight="600" color="brand.700">
                    {link.title}
                  </Text>
                  <Text fontSize="sm" color="brand.500">
                    {link.description}
                  </Text>
                </VStack>
              </Button>
            </MotionBox>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default ContactQuickLinks;
